module.exports = __webpack_public_path__ + "img/Wild_strawberries.4b77354d.jpg";